import styled from 'styled-components'

export const VideoOverlay = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .play-icon {
    color: var(--white);
    opacity: 0.5;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
`

VideoOverlay.displayName = 'VideoOverlay'
